import { boot } from 'quasar/wrappers'
import hasRanking from '../functions/has-ranking'

export default boot(({ app }) => {
	app.config.globalProperties.$hasRanking = hasRanking
})
